const htmlMsg = {
  type: 5,
  content: '        这是html消息这是html消息这是html消息这是html消息这是html消息这是html     消     息<a href="https://qq.com"><span>腾讯</span></a><br><br><br><br><br><br><br><br><br><br><br><br><br>哈哈哈<br><br><br><br><br><br><br>哈哈哈',
};

const freeMsgList = [
  // 普通
  {
    type: 4,
    content: '这是html消息<a href="https://www.baidu.com">打电话打电话打电话打电话打电话打电话打电话打电话打电话打电话打电话</a><img src="https://c2cpicdw.qpic.cn/offpic_new/0//2852060752-1762026921-4F9CA1576DF16EFD772434DD7EB245FB/0">',
  },
  // btnList快捷回复
  // {
  //   type: 4,
  //   content: '<a href="https://cloud.tencent.com/">腾讯云</a>提供三种类型的云服务器购买方式：包年包月、按量计费和竞价实例。<img src="https://c2cpicdw.qpic.cn/offpic_new/0//2852060752-1762026921-4F9CA1576DF16EFD772434DD7EB245FB/0">\n<a href="qdweb://webim/message/sendc2b?content=有" class="quick-relply-btn">有</a><a href="qdweb://webim/message/sendc2b?content=没有" class="quick-relply-btn">没有</a>',
  // },
  // // qlist
  // {
  //   type: 4,
  //   msgType: 2,
  //   content: '您可能还想问<a href="qdweb://webim/message/sendc2b?content=酒店早餐地址及开放时间酒店早餐地址及开放时间酒店早餐地址及开放时间酒店早餐地址及开放时间">酒店早餐地址及开放时间酒店早餐地址及开放时间酒店早餐地址及开放时间酒店早餐地址及开放时间</a><a href="qdweb://webim/message/sendc2b?content=介绍一下酒店的餐厅">介绍一下酒店的餐厅</a><a href="qdweb://webim/message/sendc2b?content=酒店游泳池地址及开放时间">酒店游泳池地址及开放时间</a>',
  // },
];

const batchMsg =  {
  type: 6,
  pagecount: 5,
  answer: {
    type: 4,
    datatype: 4,
    msgType: 1,
    content: '1.场景释义：\n机构老师将可约课的日程透出，让学员通过预约的方式，根据自己的情况进行课程、时间的预约<img src="https://p.qpic.cn/qidian_pic/2852199330/2020112872464fe1e0fcb8f207b12f22684eb7cc/0" alt="插图" data-alt="图片插入"><img src="https://p.qpic.cn/qidian_pic/2852199330/20201128e76fa78b5c0c9094b86b827ce084b5e1/0" alt="插图" data-alt="图片插入">',
  },
  answer_type: 1,
  list: [{
    text: '1232435',
    itemtype: '333',
    key: '345',
  }, {
    text: '653133214',
    itemtype: '333',
    key: '345',
  }, {
    text: 'fsgsaha',
    itemtype: '333',
    key: '345',
  }, {
    text: 'hasye色啊塔塔',
    itemtype: '333',
    key: '345',
  }, {
    text: '嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒嘀嗒啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊啊',
    itemtype: 'c2b',
    key: '345',
  }, {
    text: '很短了',
    itemtype: 'c2b',
    key: '345',
  }, {
    text: '很短了',
    itemtype: 'c2b',
    key: '345',
  }, {
    text: '很短了',
    itemtype: 'c2b',
    key: '345',
  }],
};

const robotForm = {
  content: [{
    fieldName: '字段1',
    fieldType: 1,
    options: {
      instances: [{
        name: '自己查询',
        id: '1082',
        dictId: '267',
        type: 'user',
      }, {
        name: '已申请',
        id: '1081',
        dictId: '267',
        type: 'user',
      }, {
        name: '准备申请',
        id: '1080',
        dictId: '267',
        type: 'user',
      }],
    },
    required: true,
    slotDefId: 207,
    slotName: '金牌商标判断',
  }, {
    fieldName: '城市',
    fieldType: 2,
    options: {
      instances: [],
    },
    required: true,
    slotDefId: 175,
    slotName: '所在城市',
  }, {
    fieldName: '城市',
    fieldType: 3,
    options: {
      instances: [],
    },
    required: true,
    slotDefId: 15,
    slotName: '所在城市',
  }],
};
const qlist = {
  type: 2,
  description: [
    {
      text: '您可以 ',
    },
    {
      text: '点击此处',
      url: 'https://member.cignacmb.com/mb-web/account/index.html#!/znkfLogin/JF',
    },
    {
      text: ' 操作在线交费。',
    },
  ],
  questions: [
    { text: '指定交费日' },
    { text: '宽限期是指什么' },
  ],
};

export default {
  htmlMsg,
  freeMsgList,
  batchMsg,
  robotForm,
  qlist,
};
